// 게이트웨이 브랜드 이름 — 흩어져 박히지 않게 여기 한곳에서만 정한다.
//
// 둘은 다른 것이다. 섞어 쓰면 안 된다:
//   서비스(포털) = '아워박스 AI 게이트웨이'  — 로그인 화면·헤더·2FA 발급자 등 플랫폼 자체
//   AI 챗봇      = 'OURi(아우리)'            — 답변하는 주체. 채팅·드라이브 어시스턴트·메신저 1차답변
//
// 챗봇 이름 확정: 마스터 2026-08-21.
export const BOT_NAME = 'OURi';
export const BOT_NAME_KO = '아우리';
export const BOT_NAME_FULL = 'OURi(아우리)';

// 이름 유래 — 화면에 한 줄로 얹는 짧은 형태. 서버 쪽 같은 값은 backend/services/branding.py BOT_ORIGIN.
export const BOT_ORIGIN = 'OUR(아워박스·우리) + i(AI·나) = 우리 회사의 AI';

export const SERVICE_NAME = '아워박스 AI 게이트웨이';
